export const iconFontAwesomeEditingTrash = (
	<i className="fa-solid fa-trash"></i>
);
